import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import * as Actions from './store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon, Button, IconButton, Checkbox, FormControlLabel } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import ReactTable from "react-table";

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    },
    customToolTip: {
        marginLeft: '16px',
        fontSize: '30px',
    }
});

class InstructorTable extends Component {

    getAddRowContent = (row) => {
        if (row.enrolled_this_course) {
            return (
                <Button
                    disabled={this.props.view_type === 'detail'}
                    variant="contained"
                    onClick={() => this.props.toggleInstructor(row, 'REMOVE')}
                >Drop
                </Button>
            )
        }
        // else if (!row.enrolled_this_course && !row.schedule_conflict) {
        else {
            return (
                <Button
                    disabled={this.props.view_type === 'detail'}
                    variant="contained"
                    onClick={() => this.props.toggleInstructor(row, 'ADD')}
                >Add</Button>
            )
        }
        // else {
        //     return (
        //         <Tooltip
        //             style={{ marginLeft: '16px', fontSize: '30px' }}
        //             classes={{ tooltip: this.props.theme.customToolTip }}
        //             title=" Instructor already assigned in a course during this time period">
        //             <Icon>cancel</Icon>
        //         </Tooltip>
        //     )
        // }

    }

    getPrimaryInstructorColumn = (row) => {
        return (
            <FormControlLabel
                
                control={
                    <Checkbox
                        style={{ padding: '0px', marginTop: '0px', marginBottom: '0px', paddingLeft: '10px' }}
                        checked={(row.PrimaryInstructor === 1)}
                        onChange={(event) => this.props.togglePrimaryInstructor(row.instructor_id, (event.target.checked ? 1 : 0))}
                        color="primary"
                        variant="outlined"
                    />
                }
                label=""
                disabled={!row.enrolled_this_course}
            />
        )
    }

    render() {
        const rows = this.props.allInstructors
        const { } = this.props

        return (

            <ReactTable
            getTrProps={(state, rows, column) => {
                if (rows) {
                    if (rows.original.enrolled_this_course) {
                        return { style: { backgroundColor: 'rgba(33, 134, 29, 0.37)'}}
                    }
                    // else if (rows.original.schedule_conflict === 1) {
                    //     return { style: { backgroundColor: 'rgba(186, 3, 3, 0.33)'}}
                    // }
                }
                return { style: { }}
            }}
                columns={[
                    {   
                        Header: "Instructor",
                        accessor: "FullName",
                    },
                    {
                        Header: "Email",
                        accessor: "Email",
                    },
                    {
                        Header: "Actions",
                        id: "actions",
                        accessor: a => this.getAddRowContent(a)
                    },
                    {
                        Header: "Primary Instructor",
                        id: "primary_instructor",
                        accessor: a => this.getPrimaryInstructorColumn(a)
                    },
                ]}
                data={rows}
                defaultPageSize={25}
                className="-striped -highlight"
                noDataText="No Students Found"
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleInstructor: Actions.toggleInstructor,
        togglePrimaryInstructor: Actions.togglePrimaryInstructor
    }, dispatch);
}

function mapStateToProps({ scheduledCourseApp, auth }) {
    return {
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(InstructorTable)));




// WEBPACK FOOTER //
// src/main/content/scheduled_course/InstructorTable.js